import * as Yup from 'yup';
import { CreateChapterDto } from '../../../../interfaces/chapters.interface';

export const stepOneValidation = Yup.object().shape({
  title: Yup.string()
    .required('Le titre est obligatoire')
    .min(3, 'Le titre doit contenir au moins 3 caractères'),
  category: Yup.string()
    .required('La catégorie est obligatoire')
    .min(2, 'La catégorie doit contenir au moins 2 caractères'),
  description: Yup.string()
    .required('La description est obligatoire')
    .min(10, 'La description doit contenir au moins 10 caractères'),
});

const questionSchema = Yup.object().shape({
  questionAnnouncement: Yup.string().required('L\'énoncé de la question est obligatoire'),
  answerA: Yup.string().required('La réponse A est obligatoire'),
  answerB: Yup.string().required('La réponse B est obligatoire'),
  answerC: Yup.string().required('La réponse C est obligatoire'),
  answerD: Yup.string().required('La réponse D est obligatoire'),
  correctAnswers: Yup.array().of(Yup.string()).min(1, 'Au moins une bonne réponse est requise'),
  category: Yup.string().required('La catégorie est obligatoire')
});

export const stepTwoValidation = Yup.object().shape({
  questions: Yup.array()
    .of(questionSchema.nullable())
    .nullable()
    .default([])
});

export const finalStepValidation = Yup.object().shape({
  questions: Yup.array()
    .of(questionSchema)
    .min(1, 'Au moins une question est requise')
    .required('Les questions sont obligatoires')
});

export const validateStep = async (
  values: Partial<CreateChapterDto>,
  currentStep: number
): Promise<{ isValid: boolean; errors: Record<string, string> }> => {
  try {
    if (currentStep === 0) {
      await stepOneValidation.validate(values, { abortEarly: false });
    } else if (currentStep === 1) {
      // For step 2, only validate questions if they exist
      if (values.questions && values.questions.length > 0) {
        const validQuestions = values.questions.filter(q => q !== null);
        await stepTwoValidation.validate({ ...values, questions: validQuestions }, { abortEarly: false });
      }
    } else if (currentStep === 2) {
      // For the final step, ensure we have at least one valid question
      const validQuestions = values.questions?.filter(q => q !== null) || [];
      await finalStepValidation.validate({ ...values, questions: validQuestions }, { abortEarly: false });
    }
    return { isValid: true, errors: {} };
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      const errors: Record<string, string> = {};
      error.inner.forEach((err) => {
        if (err.path) {
          errors[err.path] = err.message;
        }
      });
      return { isValid: false, errors };
    }
    return { isValid: false, errors: { general: 'Une erreur est survenue lors de la validation' } };
  }
};
